import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Loader2, CalendarClock } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

const DEFAULT_REASONS = [
  "Cuaca Buruk",
  "Material Habis",
  "Waktu Habis/Kemalaman",
  "Akses Lokasi Sulit",
];

export default function RescheduleDialog({ open, onOpenChange, ticket, onDone }) {
  const [reasons, setReasons] = useState(DEFAULT_REASONS);
  const [reason, setReason] = useState("");
  const [notes, setNotes] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setReason("");
    setNotes("");
    api.get("/reference").then(({ data }) => {
      if (Array.isArray(data.reschedule_reasons) && data.reschedule_reasons.length) {
        setReasons(data.reschedule_reasons);
      }
    }).catch(() => {});
  }, [open]);

  const submit = async (e) => {
    e.preventDefault();
    if (!reason) { toast.error("Pilih alasan kendala"); return; }
    setSaving(true);
    try {
      await api.post(`/tickets/${ticket.id}/reschedule`, { reason, notes });
      toast.success("Tiket ditunda dan dikembalikan ke daftar klaim");
      onDone?.();
      onOpenChange(false);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="reschedule-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-black tracking-tighter flex items-center gap-2">
            <span className="h-9 w-9 rounded-md bg-[#F59E0B]/15 text-[#B45309] flex items-center justify-center">
              <CalendarClock className="h-5 w-5" />
            </span>
            Tunda Pekerjaan
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="text-xs text-[#4B5563] bg-[#FEF3C7] border border-[#FDE68A] rounded-md px-3 py-2">
            Setelah dikirim, PIC akan dikosongkan dan tiket kembali ke daftar Klaim Tiket. Alasan Anda akan terlihat oleh teknisi lain yang mengklaim tiket ini nanti.
          </div>

          <div>
            <label className="block text-[10px] font-bold uppercase tracking-widest text-[#4B5563] mb-1.5">
              Alasan Kendala <span className="text-[#991B1B]">*</span>
            </label>
            <select
              required
              data-testid="reschedule-reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              className="w-full h-10 px-3 rounded-md border border-[#E5E7EB] bg-white focus:outline-none focus:ring-2 focus:ring-[#F59E0B] text-sm"
            >
              <option value="">— Pilih alasan —</option>
              {reasons.map((r) => <option key={r} value={r}>{r}</option>)}
            </select>
          </div>

          <div>
            <label className="block text-[10px] font-bold uppercase tracking-widest text-[#4B5563] mb-1.5">
              Catatan Detail Lapangan
            </label>
            <textarea
              data-testid="reschedule-notes"
              rows={4}
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Contoh: Hujan lebat sejak pagi, jaringan basah tidak aman disentuh. Butuh cuaca kering."
              className="w-full px-3 py-2 rounded-md border border-[#E5E7EB] bg-white focus:outline-none focus:ring-2 focus:ring-[#F59E0B] text-sm"
            />
          </div>

          <DialogFooter>
            <button
              type="button"
              onClick={() => onOpenChange(false)}
              className="h-10 px-4 rounded-md border border-[#E5E7EB] text-sm font-semibold text-[#4B5563] hover:bg-[#F8F9FA]"
            >
              Batal
            </button>
            <button
              type="submit"
              disabled={saving}
              data-testid="reschedule-submit"
              className="h-10 px-5 rounded-md bg-[#F59E0B] hover:bg-[#D97706] text-white font-semibold flex items-center gap-2 transition-colors"
            >
              {saving && <Loader2 className="h-4 w-4 animate-spin" />}
              Kirim Reschedule
            </button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
